import { useTranslation } from 'react-i18next';

export const useTranslationImpl = <T>() => {
  const { t } = useTranslation();

  const tWrapper = (key: keyof T, options?: any) => {
    const result = t<string>(key as string, options);
    return result ? String(result) : key;
  };

  return tWrapper;
};

export const useUnsafeTranslationImpl = <T>() => {
  const { t } = useTranslation();

  const tWrapper = (key: keyof T | string, options?: any) => {
    const result = t<string>(key as string, options);
    return result ? String(result) : key;
  };

  return tWrapper;
};
